var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"7e0a664a51591a15eae6818d02ac9530fee346e2"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NODE_ENV,

  // Captura 10% das sessões para performance (ajuste conforme volume)
  tracesSampleRate: 0.1,

  // Não envia PII automaticamente (LGPD)
  sendDefaultPii: false,

  beforeSend(event) {
    // Remove IP do usuário
    if (event.user) {
      delete event.user.ip_address
    }
    return event
  },
})
